import { default as Container } from '@mui/material/Container';
import { IMAGES } from 'config/images';
import { Layout } from 'modules/minimal-ui-theme';
import { LoginButton } from './LoginButton';

export const ZENJOB_WHITE_LOGO_ALT_TEXT = 'Zenjob Pro Logo White';

const childrenStyles = {
  height: '100%',
  img: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxHeight: '65vh'
  }
};

const buttonContainer = {
  style: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    position: 'absolute',
    bottom: '12vh',
    left: '50%',
    transform: 'translateX(-50%)'
  }
};

export const LoginScreen = () => (
  <Layout backgroundColor="primary.main" childrenStyles={childrenStyles}>
    <img alt={ZENJOB_WHITE_LOGO_ALT_TEXT} src={IMAGES.proLogoWhite} />
    <Container maxWidth="sm" sx={buttonContainer.style}>
      <LoginButton />
    </Container>
  </Layout>
);
